import {
    Navigate,
    RouteObject
} from 'react-router-dom';
import {PublicHomePage} from '../features/home/pages/PublicHomePage';
import {SignOutPage} from '../features/home/pages/SignOutPage';

import {IndexPage as DashboardPage} from "../features/dashboard/pages/IndexPage";
import {AppLayout} from "../layout/AppLayout";
import {RequireAuth} from "../utils/RequireAuth.tsx";

import {ProductsLayout} from "../features/products/layout.tsx";
import {ApplicationErrorPage} from "@flexinet/ui-components";

// FNP-1960: the AWS-shaped modules were retired with the old marketplace-api
// schema. A bookmark to one of them lands on the dashboard rather than the
// router's 404, so the paths stay reserved here.
export const RETIRED_MODULE_PATHS = ['offers', 'registrations', 'metering-records', 'notification-subscriptions'];

// FNP-1858: the route table lives on its own so a test can mount it in a
// memory router, exactly as App.tsx mounts it in the browser router.
// FNP-1932: every signed-in route goes through RequireAuth.
export const routes: RouteObject[] = [{
    path: '/',
    element: <AppLayout/>,
    errorElement: <ApplicationErrorPage/>,
    children: [{
        index: true,
        element: <PublicHomePage/>
    }, {
        path: 'sign-out',
        element: <SignOutPage/>
    }, {
        path: 'dashboard',
        element: <RequireAuth><DashboardPage/></RequireAuth>
    }, {
        path: 'products/*',
        element: <RequireAuth><ProductsLayout/></RequireAuth>
    }, ...RETIRED_MODULE_PATHS.map((path) => ({
        path: `${path}/*`,
        element: <Navigate to='/dashboard' replace/>
    }))]
}];
